import { MenuItem, Select } from '@mui/material';

export function AgeSelector(props: {
  value: number;
  onChange: (value: number) => void;
}) {
  return (
    <Select
      value={props.value}
      onChange={(e) => props.onChange(+e.target.value)}
      sx={{ minWidth: 80 }}
    >
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((age) => (
        <MenuItem key={age} value={age}>
          {age}
        </MenuItem>
      ))}
    </Select>
  );
}
